/**
 * Resources on duty (who has which special skill or gear) and the command board (a bush bond / perimeter /
 * search callout: alert who's on duty or on standby, they answer Responding or Not, and on scene say what they're doing).
 */

/** Skills and gear a supervisor needs to know about on a call. The agency can rename, add or remove these. */
export const DEFAULT_RESOURCES: { code: string; label: string }[] = [
  { code: 'ba', label: 'Breath alcohol (DataMaster) operator' },
  { code: 'sfst', label: 'SFST certified' },
  { code: 'drone', label: 'Drone pilot' },
  { code: 'less_lethal', label: 'Less lethal' },
  { code: 'emt', label: 'EMT' },
  { code: 'paramedic', label: 'Paramedic' },
  { code: 'shield', label: 'Entry shield' },
  { code: 'k9', label: 'K9 handler' },
  { code: 'cit', label: 'Crisis intervention (CIT)' },
  { code: 'spanish', label: 'Speaks Spanish' },
];

export const BOARD_KINDS = {
  bush_bond: 'Bush bond (suspect ran)',
  perimeter: 'Perimeter',
  search: 'Search (missing person)',
  barricade: 'Barricaded subject',
  other: 'Other',
} as const;
export type BoardKind = keyof typeof BOARD_KINDS;

/** What a deputy is doing once on scene. */
export const BOARD_ROLES = {
  perimeter: 'On perimeter',
  k9: 'Running with K9',
  drone: 'Flying drone',
  available: 'Available for assignment',
  command: 'Command post',
  traffic: 'Traffic control',
  staging: 'Staging',
  medical: 'Medical / EMS',
  other: 'Other',
} as const;
export type BoardRole = keyof typeof BOARD_ROLES;

export const BOARD_SCOPES = { on_duty: 'Everyone on duty', standby: 'Everyone on standby' } as const;
export type BoardScope = keyof typeof BOARD_SCOPES;
